module.exports = __webpack_public_path__ + "static/img/masthead.1d25e0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/masthead.jpg
// module id = AQ8j
// module chunks = 1